import { Component } from '@angular/core';
import { Observable, switchMap } from 'rxjs';

import { Product } from '@features/contacts/models/product';
import { Router } from '@angular/router';
import { ContactEventService, ContactInfo } from '@features/contacts/services/contact-event.service';
import { ClientService } from '@features/contacts/services/client.service';

@Component({
  selector: 'spark-contact-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss']
 })
export class ClientProductListComponent {
  public load$!: Observable<Product.Summary[]>;

  protected contact$: Observable<ContactInfo> =
    this.contactEventService.selectedContactInfo$;

  constructor(
    private contactEventService: ContactEventService,
    private clientService: ClientService,
    public router: Router
  ) {
    this.load$ = this.contact$.pipe(
      switchMap((contact) => this.clientService.getSettledProducts(contact.id))
    );
  }
}
